import { fork } from 'redux-saga/effects';

import { RootSagaReturnType } from 'sagas/types';

import OutletGateway from 'api/Outlet';
import watchGetOutletListing from './GetOutletListing';

export default (api: OutletGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchGetOutletListing, api);
    }

    return {
        rootSaga,
    };
};
